/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Not_FoundInputs */

const en_us2_body_assessment_not_found = /** @type {(inputs: Body_Assessment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That assessment isn't there any more.`)
};

const pt_br2_body_assessment_not_found = /** @type {(inputs: Body_Assessment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa avaliação não existe mais.`)
};

const es_419_body_assessment_not_found = /** @type {(inputs: Body_Assessment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa evaluación ya no existe.`)
};

const pt_pt2_body_assessment_not_found = /** @type {(inputs: Body_Assessment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa avaliação já não existe.`)
};

const fr_fr2_body_assessment_not_found = /** @type {(inputs: Body_Assessment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette évaluation n'existe plus.`)
};

const de_de2_body_assessment_not_found = /** @type {(inputs: Body_Assessment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Auswertung gibt es nicht mehr.`)
};

const it_it2_body_assessment_not_found = /** @type {(inputs: Body_Assessment_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa valutazione non esiste più.`)
};

/**
* | output |
* | --- |
* | "That assessment isn't there any more." |
*
* @param {Body_Assessment_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_not_found = /** @type {((inputs?: Body_Assessment_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_not_found(inputs)
	if (locale === "es-419") return es_419_body_assessment_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_not_found(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_not_found(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_not_found(inputs)
	return en_us2_body_assessment_not_found(inputs)
});
export { body_assessment_not_found as "body_assessment.not_found" }